import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 5h-6a7 7 0 1 0 0 14h6a7 7 0 0 0 7 -7l-.007 -.303a7 7 0 0 0 -6.993 -6.697z","key":"svg-0"}]]

/**
 * IconCapsuleHorizontalFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItY2Fwc3VsZS1ob3Jpem9udGFsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xNSA1aC02YTcgNyAwIDEgMCAwIDE0aDZhNyA3IDAgMCAwIDcgLTdsLS4wMDcgLS4zMDNhNyA3IDAgMCAwIC02Ljk5MyAtNi42OTd6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/capsule-horizontal-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCapsuleHorizontalFilled = createReactComponent('filled', 'capsule-horizontal-filled', 'CapsuleHorizontalFilled', __iconNode);

export default IconCapsuleHorizontalFilled;